(() => {
  if (!customElements.get('pk-cart-offer-clock')) {
    customElements.define('pk-cart-offer-clock', class extends HTMLElement {
      connectedCallback() {
        this.setAttribute('role', 'timer');
        this.setAttribute('aria-live', 'off');
        this.updateClock = () => {
          let config;
          try { config = JSON.parse(document.getElementById('PKOpeningSaleConfig').textContent); } catch (_) { this.hidden = true; return; }
          const now = Date.now(), start = Date.parse(config.startsAt), end = Date.parse(config.endsAt);
          const catalogOffer = this.closest('[data-pk-cart-catalog-offer]');
          const eligible = !catalogOffer || config.catalogPricing === true || config.productIds?.map(String).includes(catalogOffer.dataset.productId);
          if (!Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end || !eligible) {
            this.hidden = true;
            if (catalogOffer) catalogOffer.hidden = true;
            return;
          }
          if (catalogOffer) catalogOffer.hidden = false;
          const seconds = Math.floor((end - now) / 1000);
          const hours = Math.floor(seconds / 3600);
          const minutes = String(Math.floor(seconds / 60) % 60).padStart(2, '0');
          const remainingSeconds = String(seconds % 60).padStart(2, '0');
          const label = `${String(hours).padStart(2, '0')}h ${minutes}m ${remainingSeconds}s`;
          this.hidden = false;
          if (this.textContent !== label) this.textContent = label;
          this.setAttribute('aria-label', `Offer ends in ${hours} hours, ${minutes} minutes, ${remainingSeconds} seconds`);
        };
        this.updateClock();
        this.clockInterval = setInterval(this.updateClock, 1000);
      }
      disconnectedCallback() { clearInterval(this.clockInterval); }
    });
  }
  if (!customElements.get('pk-cart-offerings')) {
    customElements.define('pk-cart-offerings', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('change', event => event.stopPropagation());
      }
    });
  }
})();

// Keep checkout unavailable until the latest cart response has rendered.
(() => {
  let pending = 0;
  const sync = () => {
    const drawer = document.querySelector('cart-drawer');
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    const button = document.getElementById('CartDrawer-Checkout');
    if (footer) { footer.inert = pending > 0; footer.setAttribute('aria-busy', String(pending > 0)); }
    if (button) {
      button.disabled = pending > 0 || drawer?.classList.contains('is-empty');
      if (pending > 0) { button.dataset.pkPendingLabel ||= button.textContent; button.textContent = 'Updating…'; }
      else if (button.dataset.pkPendingLabel) { button.textContent = button.dataset.pkPendingLabel; delete button.dataset.pkPendingLabel; }
    }
  };
  window.pkCartPending = () => {
    pending += 1; sync();
    let released = false;
    return () => { if (released) return; released = true; pending = Math.max(0, pending - 1); sync(); };
  };
  document.addEventListener('click', event => {
    if (pending && event.target.closest?.('#CartDrawer .drawer__footer')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
})();

